import React from "react";

const ReportsFilter = () => {
  return <div></div>;
};

export default ReportsFilter;
